const ranking = [
  { rank: 1, title: '某顶流男星深夜密会视频曝光', heat: '980万', trend: 'up', tag: '新瓜' },
  { rank: 2, title: '知名女艺人偷税漏税被调查', heat: '860万', trend: 'up', tag: '跟进' },
  { rank: 3, title: '综艺录制现场嘉宾直接对骂', heat: '740万', trend: 'hot', tag: '独家' },
  { rank: 4, title: '头部主播数据造假铁证如山', heat: '650万', trend: 'up', tag: '实锤' },
  { rank: 5, title: '导演选角黑幕牵出多位大咖', heat: '580万', trend: 'new', tag: '爆料' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1100px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">实时热搜榜</h2>
          <span className="text-xs text-foreground-400 mt-2">TOP 5</span>
        </div>

        <div className="space-y-3">
          {ranking.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-background-100 hover:bg-background-200/70 border border-background-200/50 rounded-xl px-5 py-4 transition-all cursor-pointer group"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-lg font-bold shrink-0 ${
                i === 0 ? 'bg-primary-500 text-background-50' :
                i === 1 ? 'bg-accent-500 text-background-50' :
                i === 2 ? 'bg-secondary-500 text-background-50' :
                'bg-background-300 text-foreground-600'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </p>
              </div>

              <span className={`text-[10px] font-semibold px-2 py-0.5 rounded whitespace-nowrap ${
                item.tag === '新瓜' ? 'bg-primary-100 text-primary-700' :
                item.tag === '实锤' ? 'bg-accent-100 text-accent-800' :
                item.tag === '独家' ? 'bg-secondary-200 text-secondary-800' :
                'bg-background-200 text-foreground-600'
              }`}>{item.tag}</span>

              <div className="flex items-center gap-1 text-xs shrink-0">
                <span className="text-foreground-400">{item.heat}</span>
                <span className={`${
                  item.trend === 'up' ? 'text-primary-500' :
                  item.trend === 'hot' ? 'text-accent-500' :
                  'text-secondary-500'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.trend === 'hot' && <i className="ri-fire-fill"></i>}
                  {item.trend === 'new' && <i className="ri-sparkling-line"></i>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}